"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var Svg_1 = __importDefault(require("../Svg"));

var RezdyMark = function RezdyMark(_a) {
  var fill = _a.fill,
      props = __rest(_a, ["fill"]);

  return react_1.default.createElement(Svg_1.default, __assign({}, props), react_1.default.createElement("path", {
    d: "M256,1C115.1,1,1,115.1,1,256s114.1,255,255,255s255-114.1,255-255S396.7,1,256,1z M384.6,396.1\n    c-10,20.6-28.5,23-48.6,21.7c-26.1-1.7-37.7-31.6-32.5-52.1c5.2-20.6,49.2-34.4,66.2-20.2C387.7,360.6,393.9,376.8,384.6,396.1z\n     M368.9,238.2c-42.6,28.1-192.8,75.5-134.9,94.6c0,0,22.4,3.1,22.6,12.4c0.2,16.9-13.1,19.1-18.4,17.5\n    c-14.2-4.1-28.1,2.6-68.3,17.1c-54.9,19.7-86.9-43.8-36-67.8c1.4-0.8,121.4-62.6,122.7-63.4c56.3-29.5,12.3-69.7-38.2-48.3\n    c-36.4,18.8-71.2,4.1-87.9-30.2c-28.3-65.3,71.6-99.8,103.9-43.4c18.7,27,65.8,35.4,90.6,23.7C389.1,118.8,430.8,200.7,368.9,238.2\n    z",
    fill: fill
  }));
};

exports.default = RezdyMark;
RezdyMark.displayName = 'RezdyMark';